<template>
  <div id="app" class="app" :class="tplClass">
    <!-- 投票已下线 -->
    <div style="height: 100%" v-if="isOffline">
      <div class="offline">
        <div class="placeholder"></div>
        <div>活动已下线</div>
      </div>
    </div>
    <!-- 投票未下线 -->
    <div class="" style="height: 100%" v-if="dataLen">
      <!-- 投票未开始 -->
      <not-started :data="data" v-if="!isStarted && !this.apiParams.isPreview"></not-started>
      <!-- 投票开始 -->
      <div style="height: 100%">
        <router-view></router-view>
        <van-tabbar v-model="active" route safe-area-inset-bottom @change="handleTabBarChange">
          <van-tabbar-item v-for="(item, idx) in tabBarData" :key="idx" :name="item.name" :replace="true" :to="item.to"
            :icon="item.icon">{{ item.text }}</van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
  </div>
</template>


<script>
// debug
import VConsole from "vconsole";
const host = window.location.protocol + "//" + window.location.host;
if (host.indexOf("qiludev.com") > -1) {
  var vConsole = new VConsole();
  var xhr = new XMLHttpRequest();
  xhr._noVConsole = false; // 不会显示到 tab 中
}
// end debug
import { WebBridgeApi } from "ijsbridge";
import { tracking } from './utils/tracking';
import Fingerprint from 'fingerprintjs';
import NotStarted from "./components/NotStarted";
import { isWechat, isApp, getSpeToken } from './utils/utils';
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      isStarted: false, // 投票是否开始
      isOffline: false, // 是否下线
      data: {}, // 渲染页面
      dataLen: 0, // 数据长度
      active: 0, // 页脚tab index
      tplClass: "", // 模板类型
      apiParams: {
        // 请求接口参数
        id: "",
        isPreview: 0,
      },
      voteText: "投票", // 按钮以及相关文字 投票 点赞
      id: null, // 活动id
      orgid: null,
      type: null, // ! 前后台相反：type = 1，组合投票 0，单一投票
      queryConfig: {
        // 请求接口配置
        type: "axios",
        url: "", // 变量
        method: "GET", // 变量
        data: null, // 变量
        header: {
          jwt: "",
          orgid: this.orgid || 29,
          e: 1, // 是否加密，1 加密 0 不加密
        },
        timeout: 60000,
        interceptor_req: null,
        interceptor_res: null,
        orgid: this.orgid || 29,
      },
      tabBarData: [], // tabbar
    };
  },
  components: {
    NotStarted,
  },
  watch: {},
  computed: {
    isWechat() {
      return isWechat()
    },
    isApp() {
      return isApp()
    },
  },
  methods: {
    // 判断投票是否已开始
    checkStarted(str) {
      let now = new Date().getTime();
      let target = str.substring(0, 19).replace(/-/g, "/");
      let timestamp = new Date(target).getTime();
      if (now < timestamp) {
        this.isStarted = false;
      } else {
        this.isStarted = true;
      }
    },
    // 底部 tabbar 数据  
    getTabBarData() {
      let arr = [{
        name: "vote",
        to: `/vote?id=${this.id}&active=0&isPreview=0&type=${this.type}`, // 此处暂时只能这么写死。。。
        icon: "home-o",
        text: this.voteText,
      }]
      let arrRank = [
        {
          name: "rank",
          to: `/rank?id=${this.id}&active=1&isPreview=0&type=${this.type}`,
          icon: "ascending",
          text: "排行榜",
        }]
      let arrDesc = [
        {
          name: "desc",
          to: `/desc?id=${this.id}&active=2&isPreview=0&type=${this.type}`,
          icon: "wap-nav",
          text: `${this.voteText}说明`,
        }
      ]
      if (this.data.rank_display == 1) {
        arr = arr.concat(arrRank)
      }
      if (this.type == 0) {
        arr = arr.concat(arrDesc)
      }
      if (this.orgid) {
        arr.forEach(ele => {
          ele.to += `&orgid=${this.orgid}`
        });
      }
      this.tabBarData = arr;
    },
    async init() {
      // 安卓手动取消3秒遮罩
      WebBridgeApi.requestApi('hideLoading', {});
      // ? 此处不判断登录因为JS桥会直接唤起登录页面，未登录用户无法浏览
      // ? 因此移至投票时 OptionList 再判断
      this.orgid = this.$utils.getUrlParams("orgid");
      this.id = this.$utils.getUrlParams("id");
      const localSpeToken = localStorage.getItem("voteSpeToken");
      const speToken = getSpeToken();
      // 获取orgid，以便开启接口加密请求
      if (this.orgid) {
        this.$store.commit("setOrgId", this.orgid);
        this.$store.commit("setQueryConfig", this.queryConfig);
        if (localSpeToken != speToken) await this.handleWebLoginExcuted();
        this.updateQueryHeader()
      }
      if (this.id) {
        this.apiParams.id = this.id;
        this.type = this.$utils.getUrlParams("type") == 1 ? 1 : 0; // 0 单一投票 1 组合投票
        const isPreview = this.$utils.getUrlParams("isPreview") * 1;
        // isPreview 字段仅限后台预览页面有效 且有效值仅为 1
        // 正式线上环境无需此字段
        if (isPreview) this.apiParams.isPreview = isPreview
        await this.getData()
      } else {
        this.$toast.fail("投票未找到！");
      }
    },
    async handleWebLoginExcuted() {
      const loginToken = getSpeToken();
      if (loginToken) {
        const targetUrl = `https://app-auth.iqilu.com/member/login_state`;
        const res = await axios.get(`${targetUrl}?__token__=${loginToken}`)
        // console.log('APP.VUE web登录res', res);
        if (res.data.code == 1) {
          localStorage.setItem("voteJWT", res.data.data.token);
          localStorage.setItem("voteSpeToken", loginToken);
          let query = JSON.parse(JSON.stringify(this.$store.state.queryConfig));
          query.header.jwt = res.data.data.token;
          this.$store.commit("setQueryConfig", query);
        } else if (res.data.code == 0) {
          this.$toast.fail("登录失败，请重新登录");
        }
      }
    },
    /* 
      此方法确定这次投票所选用的
      缓存用户信息
      模板  
      用户是否需要登录
      投票活动id
      单选or多选
    */
    async getData() {
      /* 
        fetchApi：加密请求 接口   
        urlKeyValue：加密请求 参数
        混合使用：
        如果是get urlKeyValue(this.apiParams)拼到 url
        如果是post urlKeyValue(this.data)到 body
      */
      // ! 需要兼容之前的没有 orgid 即请求未加密的版本
      // ! 判断依据为且仅为 url 中的 orgid 参数
      let response = null;
      let targetUrl = this.type == 1 ? this.$apis.voteGroupInfo : this.$apis.voteInfo; // 1 为组合投票
      if (this.orgid) {
        let query = JSON.parse(JSON.stringify(this.$store.state.queryConfig));
        query.url = targetUrl;
        query.params = this.apiParams;
        query.method = "GET";
        response = await this.$fetchApi(query);
      } else {
        response = await this.$get(targetUrl, this.apiParams);
      }
      console.log("获取投票基本数据", response);
      if (response.data.msg === "success") {
        this.data = response.data.data;
        this.dataLen = Object.keys(this.data);
        this.data.isPreview = this.apiParams.isPreview;
        document.title = this.data.title;
        if (this.data.tmpl_id == "0" || this.data.tmpl_id == "1") {
          this.tplClass = "tplClass01 blue grid"; // 蓝色宫格
        } else if (this.data.tmpl_id == "2") {
          this.tplClass = "tplClass02 red grid"; // 红色宫格
          document.body.style.setProperty('--themeColor', '#d24633');
        } else if (this.data.tmpl_id == "3") {
          this.tplClass = " tplClass03 blue line"; // 蓝色单列
        } else if (this.data.tmpl_id == "4") {
          this.tplClass = "tplClass04 red line"; // 红色单列
          document.body.style.setProperty('--themeColor', '#d24633');
        }
        this.checkStarted(this.data.stime); // 判断投票是否已开始
        this.updateStore();
        this.getTabBarData();
        let options = tracking.getPageAccessTrackingOptions && tracking.getPageAccessTrackingOptions()
        if (options) tracking.onLoad(options)
        if (this.data.is_login == 1) {
          this.fetchAnonToken();
        }
      } else {
        this.$toast.fail(response.data.msg);
        if (response.data.code == "10018") {
          this.isOffline = true
        }
      }
      return;
    },
    // 全局变量存储
    updateStore() {
      this.$store.commit("setVoteInfo", this.data);
      this.voteText = this.data.button_type == 0 ? "投票" : "点赞";
      this.$store.commit("setVoteText", this.voteText);
      // console.warn("投票初始化this.$store.state全局变量存储", this.$store.state)
    },
    // 获取匿名牌子
    fetchAnonToken() {
      let query = JSON.parse(JSON.stringify(this.$store.state.queryConfig));
      query.url = this.$apis.voteAnonToken;
      query.method = "POST";
      delete query.data;
      delete query.params;
      delete query.header.jwt;
      this.$fetchApi(query).then((res) => {
        if (res.data.code == 1) {
          query.header['jwt-anon'] = res.data.data;
          this.$store.commit("setQueryConfig", query);
          // console.log("匿名牌子 this.$store.state.queryConfig", this.$store.state.queryConfig);
        }
      });
    },
    // 不同状态 config
    updateQueryHeader() {
      let query = JSON.parse(JSON.stringify(this.$store.state.queryConfig));
      const fp = new Fingerprint().get();
      query.header.orgid = this.queryConfig.orgid = this.orgid;
      query.header.fp = fp;
      query.header.bw = this.isApp ? "app" : this.isWechat ? "wechat" : "other";
      localStorage.getItem("voteJWT") ? query.header.jwt = localStorage.getItem("voteJWT") : "";
      this.$store.commit("setQueryConfig", query);
    },
    // 底部 tabbar 切换
    handleTabBarChange(e) {
      let options = tracking.getPageAccessTrackingOptions && tracking.getPageAccessTrackingOptions(e)
      if (options) tracking.onLoad(options)
    }
  },
  created() {
    this.init();
  },
  mounted() {

  }
};
</script>

<style>
body {
  /* --themeRed: #d24633; */
  /* --themeBlue: #66c3fe; */
  --themeColor: #66c3fe;
}

.app {
  width: 100%;
  height: 100%;
  max-width: 432px;
  margin: 0 auto;
  overflow-x: hidden;
  background: #f6f6f6;
}

.app .van-tabbar-item--active {
  color: var(--themeColor);
}


.van-tabbar--fixed {
  z-index: 999 !important;
}

.offline {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: .4rem;
  color: #666;
  font-weight: bold;
  text-align: center;
}

.placeholder {
  height: 2.24rem;
  background: url(./assets/images/bg-offline.png) center center/contain no-repeat;
}
</style>